// autogenerated, do not modify

export default {
  "ActivationCode.AlreadyHasCards": "It looks like you already have an account. Please login",
  "ActivationCode.ButtonText": "Next",
  "ActivationCode.FieldsAreRequired": "Fields are required",
  "ActivationCode.FindActivationCode": "You can find the activation code on the backside of your MTXC simcard:",
  "ActivationCode.Header": "Activation Code",
  "ActivationCode.Placeholder": "Enter Activation Code",
  "ActivationCode.WrongFormat": "Activation code is invalid",
  "Axios.ConnectionError": "No Internet connection. Please check your network connection and APN settings (you need “internet” in APN line).",
  "Axios.Error": "Error {status}",
  "Axios.ServerError": "Something went wrong. We're working on getting this fixed, please try again later.",
  "Axios.TimeoutError": "Server timeout error. Please try again.",
  "Common.ActivationCode": "Activation Code",
  "Common.Back": "Back",
  "Common.Email": "Email",
  "Common.Name": "Name",
  "Common.Next": "Next",
  "Common.Password": "Password",
  "Common.Phone": "Phone",
  "Common.SIM": "SIM",
  "Confirmation.ActivateMySim": "Activate My SIM",
  "Confirmation.Header": "Please confirm your details",
  "ForgotPassword.BackToLogin": "Back to sign in page",
  "ForgotPassword.ButtonText": "Send Recovery Code",
  "ForgotPassword.ChangePassword": "Set New Password",
  "ForgotPassword.CheckYourEmailOrPhone": "Please check your email for your new password.",
  "ForgotPassword.CheckYourPhone": "Please check your phone for your new password.",
  "ForgotPassword.EnterEmailOrPhone": "Please enter your email",
  "ForgotPassword.EnterNewPassword": "Please  specify your new password",
  "ForgotPassword.EnterPhone": "Please enter your phone number",
  "ForgotPassword.Header": "Password Recovery",
  "ForgotPassword.NewPassword": "New password",
  "ForgotPassword.NewPasswordConfirmation": "Confirm password",
  "ForgotPassword.PasswordAreTooWeak": "Password is too weak. Please specify stronger password!",
  "ForgotPassword.PasswordChanged": "Password successfully changed!",
  "ForgotPassword.PasswordsDoesNotMatch": "Passwords does not match!",
  "ForgotPassword.RecoveryTokenInvalid": "Your password recovery link is outdated. Please try to restore password again.",
  "ForgotPassword.ScoreWord-good": "Good",
  "ForgotPassword.ScoreWord-okay": "Okay",
  "ForgotPassword.ScoreWord-strong": "Strong",
  "ForgotPassword.ScoreWord-stronger": "Stronger",
  "ForgotPassword.ScoreWord-weak": "Weak",
  "ForgotPassword.TryAgain": "Restore Password",
  "ForgotPassword.UnableToChangePassword": "Unable to change password! Please try again from scratch!",
  "Login.ActivateCard": "Start using a SIM",
  "Login.AlreadyHaveAccount": "You already have an account. Please log in.",
  "Login.ForgotPassword": "Forgot Password",
  "Login.Header": "Login",
  "Login.Login": "Login",
  "Login.Or": "or",
  "Login.Signup": "Signup",
  "Login.TryLogin": "Please sign in or register an account if you don't have it yet.",
  "Menu.ContactUs": "Contact Us",
  "Menu.Coverage": "Coverage",
  "Menu.Faq": "FAQ",
  "Menu.HowItWorks": "How it works",
  "Menu.Pricing": "Pricing",
  "Register.AlreadyHaveAccount": "Already have an account?",
  "Register.ButtonText": "Register",
  "Register.ChooseFile": "Choose file",
  "Register.ConfirmEmail": "Confirm Email",
  "Register.ConfirmPassword": "Confirm Password",
  "Register.ConfirmPhone": "Confirm Phone number",
  "Register.Country": "Country",
  "Register.Email": "Email",
  "Register.EmailWrongFormat": "Email is not correct",
  "Register.EmailsDontMatch": "Emails don't match",
  "Register.FirstName": "First Name",
  "Register.FirstNameHint": null,
  "Register.Header": "Please provide your details",
  "Register.IdentityHint": "(You can do it later)",
  "Register.LastName": "Last Name",
  "Register.LastNameHint": null,
  "Register.NonLatinError": "Only latin characters, numbers and punctuation marks are allowed",
  "Register.Password": "Password",
  "Register.PasswordsDontMatch": "Passwords don't match",
  "Register.Phone": "Phone number",
  "Register.PhoneHint": null,
  "Register.PhonesDontMatch": "Phone numbers don't match",
  "Register.ShortPassword": "Password is too short (at least 6 symbols)",
  "Register.ShouldAgreeWithTerms": "You Should Agree with Terms & Conditions",
  "Register.TermsAndConditions": "You must read and accept MTX Connect Terms & Conditions to continue",
  "Register.UploadIdentity": "Upload a scan of identification document",
  "Register.UploadWrongFormat": "File should be in jpg format",
  "Register.countryEmpty": "Country is Required",
  "Register.emailEmpty": "Email is Required",
  "Register.firstNameEmpty": "First Name is Required",
  "Register.lastNameEmpty": "Last Name is Required",
  "Register.passwordEmpty": "Password is Required",
  "Register.phoneEmpty": "Phone number is Required",
  "Shared.ErrorPhoneMsg": "Please use valid phone number",
  "Verify.Title": "Thank you! Your email was verified.",
}



// WEBPACK FOOTER //
// ./app/javascript/components/application/locales/en.js